import mutations from './mutations';
import actions from './actions';
import getters from './getters';
const orderStore = {
    state: {
        isOrder: null
    },
    mutations,
    actions,
    getters
};

export default orderStore;
